<template>
  <div class="chart-container" :style="'height: ' + height + 'px'">
    <template v-if="dataIsLoaded">
      <canvas :id="canvasId"></canvas>
    </template>
  </div>
</template>

<script>
import {Chart} from 'chart.js';
import utils from "../../services/utils";

export default {
  name: "ChartPie",
  props: {
    chartData: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    dataIsLoaded: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      canvasId: utils.generateClientId()
    }
  },
  mounted() {
    if (this.dataIsLoaded) {
      this.$nextTick(() => {
        this.buildChart();
      })
    }
  },
  watch: {
    dataIsLoaded(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.buildChart();
        })
      }
    }
  },
  methods: {
    buildChart() {
      new Chart(document.getElementById(this.canvasId), {
        type: 'pie',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          onClick: (event, elements) => {
            if (elements[0] && elements[0]._chart.chart.data) {
              const i = elements[0]._index
              const chart = elements[0]._chart.chart.data
              this.$emit('click', {
                type: chart.datasets[0].label,
                id: (chart.datasets[0].ids) ? chart.datasets[0].ids[i] : null,
                label: chart.labels[i],
              });
            }
          },
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.chart-container {
  position: relative;
  margin: auto;
  width: 100%;
}
</style>
